import { createRoot } from 'react-dom/client'
import { RecoilRoot } from '@hotmart/hub-store'
import { ApiClientProvider } from '@hotmart/hub-api-client'
import i18n from 'config/i18n'
import setupNewRelicAgent from 'config/newRelic'
import setupSentry from 'config/sentry'
import { I18nextProvider } from 'react-i18next'
import GrowthBookInitializer from 'config/growthBook/intializer'
import Routes from './routes'

import './style.scss'

setupNewRelicAgent()
setupSentry()

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <RecoilRoot>
    <I18nextProvider i18n={i18n}>
      <ApiClientProvider>
        <GrowthBookInitializer>
          <Routes />
        </GrowthBookInitializer>
      </ApiClientProvider>
    </I18nextProvider>
  </RecoilRoot>
)
